import { useContext, useMemo } from 'react';
import { ShopConfigContext } from '@jetshop/core/components/ConfigProvider';
import throwErrorInDev from '../helpers/throwErrorInDev';
export function useShopConfig() {
    const config = useContext(ShopConfigContext);
    if (!config) {
        throwErrorInDev(true, 'Could not find ShopConfigContext. Is your shop.config.js valid?');
    }
    return useMemo(() => config, [config]);
}
//# sourceMappingURL=useShopConfig.js.map